import api from './api';

const JobService = {
    list: (params) => api.get('/jobs', { params, paramsSerializer: { indexes: null } }).then(r => r.data),
    get: (id) => api.get(`/jobs/${id}`).then(r => r.data),
    /** Suggested next case number (e.g. "2026-0013"); case numbers are optional. */
    nextNumber: () => api.get('/jobs/next-number').then(r => r.data.number),
    create: (payload) => api.post('/jobs', payload).then(r => r.data),
    update: (id, payload) => api.put(`/jobs/${id}`, payload).then(r => r.data),
    setStatus: (id, status) => api.patch(`/jobs/${id}/status`, { status }).then(r => r.data),
    setSchedule: (id, scheduledDate, scheduledStart = null, scheduledEnd = null) =>
        api.patch(`/jobs/${id}/schedule`, { scheduledDate, scheduledStart, scheduledEnd }).then(r => r.data),
    payments: (id) => api.get(`/jobs/${id}/payments`).then(r => r.data),
    /** Records a payment ({ amount, paidOn, note }); returns the job with the new totals. */
    addPayment: (id, payload) => api.post(`/jobs/${id}/payments`, payload).then(r => r.data),
    deletePayment: (id, paymentId) => api.delete(`/jobs/${id}/payments/${paymentId}`).then(r => r.data),
    setAssignees: (id, userIds) => api.put(`/jobs/${id}/assignees`, { userIds }).then(r => r.data),
    setLocation: (id, latitude, longitude) => api.patch(`/jobs/${id}/location`, { latitude, longitude }).then(r => r.data),
    remove: (id) => api.delete(`/jobs/${id}`),
    setStep: (id, code, done, date) => api.put(`/jobs/${id}/steps/${code}`, { done, date }).then(r => r.data),
    files: (id) => api.get(`/jobs/${id}/files`).then(r => r.data),
    /** Uploads a PDF or photo; `target` may hold a stepCode or visitId. */
    uploadFile: (id, file, target = {}, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        if (target.stepCode) form.append('stepCode', target.stepCode);
        if (target.visitId) form.append('visitId', target.visitId);
        return api.post(`/jobs/${id}/files`, form, {
            onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
        }).then(r => r.data);
    },
    /** Fetches a file with the auth header and returns a Blob. */
    fetchFile: (id, fileId) => api.get(`/jobs/${id}/files/${fileId}`, { responseType: 'blob' }).then(r => r.data),
    /** First page of a PDF as a PNG blob (server-rendered thumbnail). */
    filePreview: (id, fileId) => api.get(`/jobs/${id}/files/${fileId}/preview`, { responseType: 'blob' }).then(r => r.data),
    deleteFile: (id, fileId) => api.delete(`/jobs/${id}/files/${fileId}`).then(r => r.data),
    notes: (id) => api.get(`/jobs/${id}/notes`).then(r => r.data),
    addNote: (id, body) => api.post(`/jobs/${id}/notes`, { body }).then(r => r.data),
    updateNote: (id, noteId, body) => api.put(`/jobs/${id}/notes/${noteId}`, { body }).then(r => r.data),
    deleteNote: (id, noteId) => api.delete(`/jobs/${id}/notes/${noteId}`),
    visits: (id) => api.get(`/jobs/${id}/visits`).then(r => r.data),
    createVisit: (id, payload) => api.post(`/jobs/${id}/visits`, payload).then(r => r.data),
    updateVisit: (id, visitId, payload) => api.put(`/jobs/${id}/visits/${visitId}`, payload).then(r => r.data),
    deleteVisit: (id, visitId) => api.delete(`/jobs/${id}/visits/${visitId}`),
    surveyValues: () => api.get('/jobs/survey-values').then(r => r.data),
    sameParcel: (id) => api.get(`/jobs/${id}/same-parcel`).then(r => r.data),
    planner: (from, to, assignee) => api.get('/planner', { params: { from, to, assignee } }).then(r => r.data),
    dashboard: () => api.get('/dashboard').then(r => r.data),
    map: (params) => api.get('/jobs/map', { params, paramsSerializer: { indexes: null } }).then(r => r.data),
    nearby: (id, radius = 500) => api.get(`/jobs/${id}/nearby`, { params: { radius } }).then(r => r.data),
};

export default JobService;
